import { DETALIZATION_PERSONAL_DATA_ACTIONS } from './constants';

export const detalizationPersonalDataInitialState = {
  isFetching: false,
  isFetchingSuccess: false,
  isError: false,

  isEmailConfirmed: false,

  isDataUpdating: false,
  isDataUpdatingSuccess: false,
  isDataUpdatingError: false,

  isDataConfirming: false,
  isDataConfirmingSuccess: false,
  isDataConfirmingError: false,
  isIncorrectConfirmationCode: false,

  isSendingConfirmationCode: false,
  isSendingConfirmationCodeError: false,

  isExist: false,
  emailAddress: '',
};

const detalizationPersonalData = (state = detalizationPersonalDataInitialState, action) => {
  switch (action.type) {
    // FETCH EMAIL CONFIRM
    case DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_CONFIRM_MAIL:
      return {
        ...state,
        isEmailConfirmed: action.payload,
      };
    // FETCH DATA
    case DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA:
      return {
        ...state,
        isFetching: true,
        isFetchingSuccess: false,
        isError: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetchingSuccess: true,
        isError: false,
        isExist: action.payload.isEmailExist,
        emailAddress: action.payload.emailAddress,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetchingSuccess: false,
        isError: true,
      };
    // UPDATE DATA
    case DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA:
      return {
        ...state,
        isDataUpdating: true,
        isDataUpdatingSuccess: false,
        isDataUpdatingError: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA_SUCCESS:
      return {
        ...state,
        isDataUpdating: false,
        isDataUpdatingSuccess: true,
        isDataUpdatingError: false,
        emailAddress: action.payload,
        isExist: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA_ERROR:
      return {
        ...state,
        isDataUpdating: false,
        isDataUpdatingSuccess: false,
        isDataUpdatingError: true,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SET_UPDATE_PERSONAL_DATA_ERROR:
      return {
        ...state,
        isDataUpdatingError: action.payload,
      };
    // CONFIRM DATA
    case DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA:
      return {
        ...state,
        isDataConfirming: true,
        isDataConfirmingSuccess: false,
        isDataConfirmingError: false,
        isIncorrectConfirmationCode: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA_SUCCESS:
      return {
        ...state,
        isDataConfirming: false,
        isDataConfirmingSuccess: true,
        isDataConfirmingError: false,
        isIncorrectConfirmationCode: false,
        isExist: action.payload,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA_ERROR:
      return {
        ...state,
        isDataConfirming: false,
        isDataConfirmingSuccess: false,
        isDataConfirmingError: true,
        isIncorrectConfirmationCode: action.payload,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SET_CONFIRM_PERSONAL_DATA_ERROR:
      return {
        ...state,
        isDataConfirmingError: action.payload,
        isIncorrectConfirmationCode: action.payload,
      };
    // CONFIRMATION CODE DATA
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE:
      return {
        ...state,
        isSendingConfirmationCode: true,
        isSendingConfirmationCodeError: false,
        isIncorrectConfirmationCode: false,
        isDataConfirmingError: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE_SUCCESS:
      return {
        ...state,
        isSendingConfirmationCode: false,
        isSendingConfirmationCodeError: false,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE_ERROR:
      return {
        ...state,
        isSendingConfirmationCode: false,
        isSendingConfirmationCodeError: true,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SET_CONFIRM_MAIL:
      return {
        ...state,
        isMailConfirming: action.payload,
      };
    case DETALIZATION_PERSONAL_DATA_ACTIONS.SET_INITIAL_STATE:
      return {
        ...state,
        isDataConfirming: false,
        isDataConfirmingSuccess: false,
        isDataConfirmingError: false,
      };

    default:
      return state;
  }
};

export default detalizationPersonalData;
